export const ROUTES = {
  INVOICE: '/invoice',
  PAYMENT: '/payment/view',
  VIEW_CHECK: '/payment/viewcheck',
};
